'use client';

import { createContext, useContext, ReactNode } from 'react';
import { useCookieConsent } from '@/hooks/useCookieConsent';

const CookieConsentContext = createContext({
    consent: {
        desempenho: false,
        funcionalidades: false,
        necessarios: true
    },
    updateConsent: (newConsent: any) => {},
});

export const useCookieConsentContext = () => useContext(CookieConsentContext);

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const cookieConsent = useCookieConsent();
  return (
    <CookieConsentContext.Provider value={cookieConsent}>
      {children}
    </CookieConsentContext.Provider>
  );
}